<template>
  <v-card flat :class="['filters-sidebar', { compacto }]" elevation="3">
    <div class="filters-header">
      <v-icon color="white" size="20">mdi-filter-variant</v-icon>
      <span class="filters-title">Filtros</span>
      <v-spacer />
      <v-btn v-if="hayFiltros" icon small dark @click="limpiar" title="Limpiar filtros">
        <v-icon small>mdi-filter-remove</v-icon>
      </v-btn>
    </div>

    <v-card-text class="filters-content pa-0">

      <div class="filter-section">
        <div class="section-header">
          <v-icon small color="primary" class="section-icon">mdi-account</v-icon>
          <span class="section-title-text">Cliente</span>
        </div>
        <div class="section-content">
          <v-text-field
            v-model="f.clienteNombre"
            label="Razón social"
            prepend-inner-icon="mdi-magnify"
            color="secondary"
            dense outlined hide-details clearable
            class="filter-field"
            @input="emitirConDebounce"
          />
          <v-autocomplete
            v-model="f.clienteIds"
            :items="clientes"
            item-text="razonSocial"
            item-value="id"
            label="Clientes puntuales"
            prepend-inner-icon="mdi-account-multiple"
            color="secondary"
            dense outlined hide-details clearable multiple small-chips
            class="filter-field mt-3"
            @change="emitir"
          />
          <v-select
            v-model="f.condicionesIVA"
            :items="condicionesIVA"
            item-text="label"
            item-value="value"
            label="Condición IVA"
            prepend-inner-icon="mdi-file-percent"
            color="secondary"
            dense outlined hide-details clearable multiple small-chips
            class="filter-field mt-3"
            @change="emitir"
          />
          <v-select
            v-model="f.tiposComprobante"
            :items="tiposComprobante"
            item-text="label"
            item-value="value"
            label="Tipo de comprobante"
            prepend-inner-icon="mdi-file-document-outline"
            color="secondary"
            dense outlined hide-details clearable multiple small-chips
            class="filter-field mt-3"
            @change="emitir"
          />
          <div class="filter-hint">
            El tipo sale de la configuración del cliente; es el comprobante que se
            emitiría.
          </div>
        </div>
      </div>

      <div class="filter-section">
        <div class="section-header">
          <v-icon small color="primary" class="section-icon">mdi-tag-multiple</v-icon>
          <span class="section-title-text">Orden</span>
        </div>
        <div class="section-content">
          <v-select
            v-model="f.estados"
            :items="estadosOrden"
            label="Estado de la orden"
            prepend-inner-icon="mdi-clipboard-list"
            color="secondary"
            dense outlined hide-details clearable multiple small-chips
            class="filter-field"
            @change="emitir"
          />
          <v-select
            v-model="f.estadosPago"
            :items="estadosPago"
            label="Estado de pago"
            prepend-inner-icon="mdi-credit-card"
            color="secondary"
            dense outlined hide-details clearable multiple small-chips
            class="filter-field mt-3"
            @change="emitir"
          />
        </div>
      </div>

      <div class="filter-section">
        <div class="section-header">
          <v-icon small color="primary" class="section-icon">mdi-store</v-icon>
          <span class="section-title-text">Comercial</span>
        </div>
        <div class="section-content">
          <v-autocomplete
            v-model="f.vendedorId"
            :items="vendedores"
            item-text="nombreCompleto"
            item-value="id"
            label="Vendedor"
            prepend-inner-icon="mdi-account-tie"
            color="secondary"
            dense outlined hide-details clearable
            class="filter-field"
            @change="emitir"
          />
          <v-autocomplete
            v-model="f.depositoId"
            :items="depositos"
            item-text="nombre"
            item-value="id"
            label="Depósito"
            prepend-inner-icon="mdi-warehouse"
            color="secondary"
            dense outlined hide-details clearable
            class="filter-field mt-3"
            @change="emitir"
          />
        </div>
      </div>

      <div class="filter-section">
        <div class="section-header">
          <v-icon small color="primary" class="section-icon">mdi-calendar-range</v-icon>
          <span class="section-title-text">Fecha</span>
        </div>
        <div class="section-content">
          <v-btn-toggle v-model="atajoFecha" dense mandatory class="mb-3 atajos" @change="aplicarAtajo">
            <v-btn small value="mes">Este mes</v-btn>
            <v-btn small value="anterior">Mes anterior</v-btn>
            <v-btn small value="todo">Todo</v-btn>
          </v-btn-toggle>

          <v-menu v-model="menuDesde" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="f.fechaDesde"
                label="Desde"
                prepend-inner-icon="mdi-calendar-start"
                color="secondary"
                dense outlined hide-details clearable readonly
                class="filter-field"
                v-bind="attrs" v-on="on"
                @click:clear="setFecha('fechaDesde', null)"
              />
            </template>
            <v-date-picker
              :value="f.fechaDesde"
              locale="es"
              @input="(v) => { setFecha('fechaDesde', v); menuDesde = false }"
            />
          </v-menu>

          <v-menu v-model="menuHasta" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="f.fechaHasta"
                label="Hasta"
                prepend-inner-icon="mdi-calendar-end"
                color="secondary"
                dense outlined hide-details clearable readonly
                class="filter-field mt-3"
                v-bind="attrs" v-on="on"
                @click:clear="setFecha('fechaHasta', null)"
              />
            </template>
            <v-date-picker
              :value="f.fechaHasta"
              locale="es"
              @input="(v) => { setFecha('fechaHasta', v); menuHasta = false }"
            />
          </v-menu>
        </div>
      </div>

      <div class="filter-section">
        <div class="section-header">
          <v-icon small color="primary" class="section-icon">mdi-cash-multiple</v-icon>
          <span class="section-title-text">Monto</span>
        </div>
        <div class="section-content">
          <v-row no-gutters>
            <v-col cols="6" class="pr-1">
              <v-text-field
                v-model.number="f.montoMin"
                label="Mínimo"
                type="number"
                prefix="$"
                color="secondary"
                dense outlined hide-details clearable
                class="filter-field"
                @input="emitirConDebounce"
              />
            </v-col>
            <v-col cols="6" class="pl-1">
              <v-text-field
                v-model.number="f.montoMax"
                label="Máximo"
                type="number"
                prefix="$"
                color="secondary"
                dense outlined hide-details clearable
                class="filter-field"
                @input="emitirConDebounce"
              />
            </v-col>
          </v-row>
        </div>
      </div>

    </v-card-text>
  </v-card>
</template>

<script>
import ClienteProvider from "../../../cliente/providers/ClienteProvider";
import VendedorProvider from "../../../ventas/providers/VendedorProvider";
import DepositoProvider from "../../../deposito/providers/DepositoProvider";

/** Estado inicial de los filtros. Función para no compartir la referencia. */
const filtrosVacios = () => ({
  clienteNombre: null,
  clienteIds: [],
  condicionesIVA: [],
  tiposComprobante: [],
  estados: [],
  estadosPago: [],
  vendedorId: null,
  depositoId: null,
  fechaDesde: null,
  fechaHasta: null,
  montoMin: null,
  montoMax: null,
});

export default {
  name: "FacturacionMasivaFilters",

  props: {
    /** Dentro de un diálogo el sidebar no puede tener alto fijo ni ser sticky. */
    compacto: { type: Boolean, default: false },
  },

  data() {
    return {
      f: filtrosVacios(),
      clientes: [],
      vendedores: [],
      depositos: [],
      menuDesde: false,
      menuHasta: false,
      atajoFecha: "todo",
      debounce: null,
      condicionesIVA: [
        { label: "Consumidor final", value: "CONSUMIDOR_FINAL" },
        { label: "Responsable inscripto", value: "RESPONSABLE_INSCRIPTO" },
        { label: "Monotributista", value: "MONOTRIBUTISTA" },
        { label: "Exento", value: "EXENTO" },
        { label: "No categorizado", value: "NO_CATEGORIZADO" },
      ],
      tiposComprobante: [
        { label: "Factura A", value: "FACTURA_A" },
        { label: "Factura B", value: "FACTURA_B" },
        { label: "Factura C", value: "FACTURA_C" },
        { label: "Factura X", value: "FACTURA_X" },
      ],
      // Los valores tienen que coincidir con los enums de OrdenVentaModel.
      estadosOrden: ["CONFIRMADO", "ENVIADO", "RECIBIDO"],
      estadosPago: ["PAGADO", "PAGO_PARCIAL", "NO_PAGADO"],
    };
  },

  computed: {
    hayFiltros() {
      const v = this.f;
      return Boolean(
        v.clienteNombre
          || v.clienteIds.length
          || v.condicionesIVA.length
          || v.tiposComprobante.length
          || v.estados.length
          || v.estadosPago.length
          || v.vendedorId
          || v.depositoId
          || v.fechaDesde
          || v.fechaHasta
          || v.montoMin != null
          || v.montoMax != null
      );
    },
  },

  created() {
    this.cargarCatalogos();
  },

  beforeDestroy() {
    if (this.debounce) clearTimeout(this.debounce);
  },

  methods: {
    async cargarCatalogos() {
      try {
        const [c, v, d] = await Promise.all([
          ClienteProvider.fetchClientes(),
          VendedorProvider.fetchVendedores(),
          DepositoProvider.fetchDepositos(),
        ]);
        this.clientes = c?.data?.clienteFetch || [];
        this.vendedores = (v?.data?.vendedorFetch || []).map((x) => ({
          ...x,
          nombreCompleto: [x.nombre, x.apellido].filter(Boolean).join(" "),
        }));
        this.depositos = d?.data?.depositoFetch || [];
      } catch (e) {
        // Los catálogos son una comodidad: si fallan, los demás filtros siguen
        // funcionando y no tiene sentido romper la pantalla.
        this.clientes = this.clientes || [];
      }
    },

    emitir() {
      this.$emit("updateFilters", this.limpiarVacios(this.f));
    },

    /** Los campos de texto y número no deben disparar una consulta por tecla. */
    emitirConDebounce() {
      if (this.debounce) clearTimeout(this.debounce);
      this.debounce = setTimeout(() => this.emitir(), 400);
    },

    setFecha(campo, valor) {
      this.f[campo] = valor;
      this.atajoFecha = null;
      this.emitir();
    },

    aplicarAtajo() {
      const hoy = new Date();
      const iso = (d) => d.toISOString().slice(0, 10);

      if (this.atajoFecha === "mes") {
        this.f.fechaDesde = iso(new Date(hoy.getFullYear(), hoy.getMonth(), 1));
        this.f.fechaHasta = iso(hoy);
      } else if (this.atajoFecha === "anterior") {
        this.f.fechaDesde = iso(new Date(hoy.getFullYear(), hoy.getMonth() - 1, 1));
        this.f.fechaHasta = iso(new Date(hoy.getFullYear(), hoy.getMonth(), 0));
      } else {
        this.f.fechaDesde = null;
        this.f.fechaHasta = null;
      }
      this.emitir();
    },

    limpiar() {
      this.f = filtrosVacios();
      this.atajoFecha = "todo";
      this.emitir();
    },

    /** No se mandan claves vacías: ensucian el snapshot de filtros del lote. */
    limpiarVacios(filtros) {
      const salida = {};
      Object.entries(filtros).forEach(([k, v]) => {
        if (v == null) return;
        if (Array.isArray(v) && v.length === 0) return;
        if (v === "") return;
        salida[k] = v;
      });
      return salida;
    },
  },
};
</script>

<style scoped>
.filters-sidebar {
  height: calc(100vh - 180px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 20px;
  border-radius: 12px !important;
  background: #ffffff;
}

.filters-sidebar.compacto {
  height: auto;
  max-height: 420px;
  position: static;
  box-shadow: none !important;
}

.filters-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 12px 12px 0 0;
}

.filters-title {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.filters-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.filter-section {
  padding: 0;
  margin-bottom: 4px;
}

.section-header {
  background: #f5f7fa;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 2px solid #e1e8ed;
}

.section-icon {
  opacity: 0.9;
}

.section-title-text {
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #2c3e50;
}

.section-content {
  padding: 16px;
}

.filter-hint {
  font-size: 0.72rem;
  color: #78909c;
  margin-top: 8px;
  line-height: 1.3;
}

.atajos {
  width: 100%;
}

.atajos .v-btn {
  flex: 1;
  font-size: 0.7rem;
}
</style>
